import { useState, useEffect } from "react";
import { authenticatedGet } from "../../../api/authenticatedFetch";

const ENDPOINT = "/api/v1/forecast-predictability/term-structure";

// useTermStructure fetches the per-lead band-width term structure ON MOUNT.
// This is the read-only lead-conditional/conformal-v3 "Object A" daily structure:
// for each horizon (lead) the relative band edges low_frac/high_frac + sample size n.
//
// Returns: { points, loading, error }
export function useTermStructure() {
  const [points, setPoints] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await authenticatedGet(ENDPOINT);
        // Support both { points: [...] } and raw array responses.
        const list = res && Array.isArray(res.points) ? res.points : Array.isArray(res) ? res : [];
        if (alive) setPoints(list);
      } catch (err) {
        if (alive) setError(err);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return { points, loading, error };
}
